<template>
    <div class="main">
        <div class="body-content">
            <h3 style="margin: 0;">Upload Shipping Bill</h3>
            <div class="form-group">
                <div class="form-item">
                    <label for="fileAdd">File:</label>
                    <input type="file" id="file" @change="handleFileUpload" class="custom-file-input" accept=".pdf,.zip,application/pdf,application/zip">
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Upload</button>
                </div>
                <div>{{ message }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';



export default {
    data() {
        return {
            newContainer: {
                file: null
            },
            message: '',
            isSubmitting: false,
        };
    },
        methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) {
                this.newContainer.file = null;
                return;
            }
            const allowedTypes = ['application/pdf', 'application/zip'];
            const allowedExt = ['.pdf', '.zip'];
            const name = file.name.toLowerCase();
            const isTypeAllowed = allowedTypes.includes(file.type);
            const isExtAllowed = allowedExt.some(ext => name.endsWith(ext));
            if (!isTypeAllowed && !isExtAllowed) {
                this.newContainer.file = null;
                event.target.value = '';
                useToast().error('Only PDF and ZIP files are allowed.');
                return;
            }
            this.newContainer.file = file;
        },
        async uploadFiles() {
            if (this.isSubmitting) return;
            
            if (this.newContainer.file == null) {
                useToast().error("Select file");
                return;
            }
            
            this.isSubmitting = true;
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        //'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        //'Content-Type': 'multipart/form-data'
                    },
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity,
                    timeout: 15 * 60 * 1000, // 15 minutes timeout
                    //onUploadProgress: progressEvent => {
                    //    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    //    //console.log(`Upload progress: ${percent}%`);
                    //}
                };
                this.message = "Wait, uploading file...";
                const data = new FormData();
                data.append('file', this.newContainer.file);

                const response = await axios.post('/upload_shippingbill', data, config);
                //console.log(response)
                if (response.data[0] === 0) {
                    this.message = response.data[1];
                    useToast().error(response.data[1]);
                } else {
                    this.message = "File uploaded successfully";
                    useToast().success("File uploaded successfully");
                    //this.newContainer.file = null; // Reset the file input after successful upload
                }
            } catch (error) {
                this.message = "An error occurred during upload.";
                useToast().error(error.response?.data?.message || "An error occurred during upload.");
                console.error(error);
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>
<style scoped>
.form-item {
    width: 30%;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>